proposal = function(id, signatureType, approvalProcessId, proposalType, canEdit, cui_enabled) {
	var objProposal = form();
	var objDialog = dialog();
	// var objEntity = entity();
	var objDom	= dom(cui_enabled);
	// var objSmartfield = smartfield();
	var objAssessment = assessment();
	var objCustomRoute = customRoute();

	var objDate = date();
	var objValidation = validation();
  var cui_enabled_proposal_form = $('#cui_enabled').val();

	if (typeof(signatureType) === undefined) {
		signatureType = 'electronicPin';
	}

	if (typeof(approvalProcessId) === undefined) {
		approvalProcessId = 0;
	}

	if (typeof(proposalType) === undefined) {
		proposalType = 'course';
	}

	objProposal.ajaxTab = function(tabId, callback, cui_enabled) {
		var display = tabId.replace(/\w\S*/g, function(txt){return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();});
		display = display.replace(/-([a-z])/g, function (txt) { return txt[1].toUpperCase(); });
		var menuSelector = '#curriculog-steps-column-tooltabs';
		if (cui_enabled || cui_enabled_proposal_form) {
		menuSelector = '#curriculog-side-menu';
		}

		var currentTab = ($(menuSelector + ' .tab.active').attr('class')).match(/(\w*)-tab/)[1];
		var proposalId = app.formView.model.id,
			userId = app.formView.model.get('user');

		return $.ajax({
			url: '/proposal:' + proposalId + '/ajax/getTab',
			type: 'GET',
			data: {
				display: 'getTab' + display,
				tab: tabId,
				userId: userId
			},
			beforeSend: function() {
				objDom.addLoadingMask('#curriculog-steps-column-content');
				$(menuSelector + ' .tab').removeClass('active');
				$('.' + tabId + '-tab').addClass('active');
			},
			success: function(result) {
				// remove appropriate bindings
				switch(currentTab) {

				case 'crosslisting':
					objProposal.destroyCrosslistingBindings();
					break;

				case 'proposal-lookup':
					objProposal.destroyProposalLookupBindings();
					break;

				case 'route':
					objProposal.destroyRouteBindings();
					break;

				case 'decisions':
					objProposal.destroyDecisionBindings();
					objProposal.destroyStatusBindings();
					break;

				case 'files':
					objProposal.destroyUploadBindings();
					break;

				case 'history':
					objProposal.destroyStatusBindings();
					break;

				case 'comments':
					objProposal.destroyCommentBindings();
					break;

				}

				var tab = $(result).filter('#' + tabId);
				$('#' + tabId).replaceWith(tab);

				// reestablish appropriate bindings
				switch(tabId) {

				case 'proposal-lookup':
					objProposal.initProposalLookupBindings();
					break;

				case 'crosslisting':

					if ($('#crosslistingItems').children('.crosslisting-child').size() <= 0) {
						app.formView.model.set({crosslisted: 0});
					}
					objProposal.initCrosslistingBindings();
					break;

				case 'route':
					objProposal.initRouteBindings();
					break;

				case 'decisions':
					objProposal.initDecisionBindings();
					objProposal.initStatusBindings();
					break;

				case 'files':
					objProposal.initUploadBindings();
					break;

				case 'history':
					objProposal.initStatusBindings();
					break;

				case 'comments':
					// get comments again
					objProposal.getComments();
					objProposal.initCommentBindings();

					// Add editing styles here
					var styles = $(result).filter('style#editor-styles').contents();
					if (styles.length) {
						$('style').contents().replaceWith(styles);
					}
					break;

				}

				// set active tab
				$('#curriculog-steps-column-content li').removeClass('active');
				$('#'+tabId).addClass('active');
				Backbone.trigger('form:stretch');

				if (callback) {
					callback();
				}
        if (cui_enabled || cui_enabled_proposal_form) {
          objDom.adjustCUIFormToolbox(tabId);
        }

				objDom.removeMask('#curriculog-steps-column-content');
        if (cui_enabled || cui_enabled_proposal_form) {
          $('#'+tabId).focus();
        } else {
          $('#curriculog-steps-column-content').focus();
        }

				Curriculog.Actions.log('proposal-tab-loaded');
			}
		});
	};

	/*
	 * Function to handle S3 operations
	 */
	objProposal.s3DeleteFile = function(obj) {
		var dialog = objDialog.createBasicWarningDialog('remove-upload', function(dialog, defaults) {
			// Message
			$(dialog).append('Delete File: ' + $(obj).attr('value').replace( /.*\//, ''));
			// Actions
			defaults.buttons = {
				'Ok': function() {
					var proposalId = app.formView.model.id,
						fileId = $(obj).parent('div').parent('li').find('input[name="s3-file-id"]').val(),
						s3File = $(obj).attr('value');

					$.ajax({
						url: '/proposal:' + proposalId + '/delete-upload',
						type: 'DELETE',
						data: {
							fileId: fileId,
							s3_file: s3File
						},
						beforeSend: function() {
							objDom.addLoadingMask('#files-content');
						},
						complete: function() {
							objDom.removeMask('#files-content');
						},
						success : function() {
							objProposal.ajaxTab('files');
							Backbone.trigger('form:stretch');
						}
					});
					$(dialog).dialog('close');
				},
				'Cancel': function() {
					$(dialog).dialog('close');
				}
			};
			$(dialog).dialog(defaults);
		});
	};

	// ********************************************************************************
	// ********************************************************************************
	// ********************************************************************************
	// ***
	// ***								FORM METHODS
	// ***
	// ********************************************************************************
	// ********************************************************************************
	// ********************************************************************************

	// METHODS included:
	//   1) editField ((Proposal status = Active only) Makes individual field editable and sets up tracking, if applicable)
	//   2) loadSmartfieldData (Loads dataset of smartfield into the dialog)
	//   3) removeSmartfieldItem (Allows removal of smartfield item from proposal)
	//   4) switchFieldMode ((Helper function for editField) that converts the field from a div placeholder or disabled to its active form element)
	//   5) modifyClipboard (Loads tracking data in and out of clipboard array during editing)
	//   6) saveField (Saves individual field, including diff, if applicable)
	//   7) saveTitle (Saves the title of the Proposal)


	/**
	 * DEPRECATED
	 * Used in: (legacy assessments)
	 *  - apps/curriculog/webroot/js/objects/assessment.js
	 */
	objProposal.getCanEdit = function() {
		// This gets used any time we need to access the proposal form
		// from a remote object, like assessment. canEdit is passed into the
		// proposal object when it is instantiated.

		switch(app.formView.model.get('status')) {
			case 'unlaunched':
				edit = 1;
				break;
			case 'active':
			case 'held':
			case 'cancelled':
				if (canEdit) {
					edit = 1;
				} else {
					edit = 0;
				}
				break;
			default:
				edit = 0;
				break;
		}
		return edit;
	};

	/**
	 * DEPRECATED
	 * Used in: (legacy assessments)
	 *  - apps/curriculog/webroot/js/objects/assessment.js
	 *  - apps/curriculog/views/procedures/user/proposal.single.form.html.php
	 *  - showConflict()
	 */
	objProposal.editField = function(fieldId, canEdit, callback) {
		Backbone.trigger('form:reset');

		var obj = $('.field-' + fieldId),
			mode = (canEdit) ? 'edit' : 'view',
		// entity is not editable after launch
			proposalStatus = app.formView.model.get('status'),
			userId = app.formView.model.get('user'),
			currentStepId = app.formView.model.get('currentStepId');

		var isEntityField = ($(obj).find('.system-required-proposalEntity').length > 0) ? true : false;
		if (isEntityField && proposalStatus !== 'unlaunched') {
			return;
		}

		if (proposalStatus == 'unlaunched') {
			mode = 'edit';
		}

		var expandButtons = (mode === 'edit' && $('.field-' + fieldId).hasClass('active')) ? 0 : 1;

		dataParams = {
			mode: mode,
			canEdit: canEdit,
			status: proposalStatus,
			step: currentStepId,
			user: userId,
			display: 'getField'
		};


		$.ajax({
			url: '/proposalField:' + fieldId + '/getField',
			type: 'GET',
			data: dataParams,
			beforeSend: function() {
				objDom.addLoadingMask('.section-fieldset.field-' + fieldId);
			},
			complete: function() {
				objDom.removeMask('.section-fieldset.field-' + fieldId);
			},
			success: function(data) {
				$(obj).replaceWith(data);
				Backbone.trigger('form:stretch');

				// init ckeditor on rich text textareas
				if ( ($(data).find('.ckeditor').length > 0) && (mode === 'edit') && (! $('.field-' + fieldId).hasClass('widget-assessment')) ) {
					$('#field-'+fieldId).ckeditor();

					$('#field-'+fieldId).ckeditorGet().on('instanceReady', function(e) {
						proposalObject.deactivateImageDrop(this, function() {
							Backbone.trigger('form:stretch');
						});
					});
				}

				if ($('#show-help-text').hasClass('active')) {
					$('#field-' + fieldId).closest('.section-fieldset').find('.help').show();
					Backbone.trigger('form:stretch');
				}

				// slide buttons down, if they exist
				var buttons = $('.field-' + fieldId).find('.fieldset-buttons');
				if ((buttons.length > 0) && expandButtons) {
					$(buttons).slideDown(200, function() {
						Backbone.trigger('form:stretch');
					});
				} else {
					$(buttons).css('display','block');
					Backbone.trigger('form:stretch');
				}

				if ($('.field-' + fieldId).hasClass('widget-assessment')) {
					objProposal.bindAssessmentEvents(mode);
					assessmentObject.precacheValues();
				}


				if (mode === 'edit') {
					$('#field-' + fieldId).focus();
				}

				if (callback) {
					callback();
				}

				Curriculog.Actions.log('proposal-field-loaded');
			}
		});

	};

	/**
	 * Used in: (legacy assessments)
	 *  - apps/curriculog/webroot/js/objects/assessment.js
	 *  - editField()
	 */
	objProposal.bindAssessmentEvents = function(mode, assessmentSelectors) {
		var status = app.formView.model.get('status');
		if (status === 'unlaunched') {
			$('.widget-assessment .curriculog-smartfield-dropzone').on({
				mouseenter: function () {
					$(this).find('.remove-assessment').addClass('active');
				},
				mouseleave: function () {
					$(this).find('.remove-assessment').removeClass('active');
				}
			});
		}

		if (mode === 'edit') {
			if (assessmentSelectors === undefined) {
				assessmentSelectors = $('.widget-assessment').find('.ckeditor');
			} else {
				assessmentSelectors = assessmentSelectors.join();
			}

			$(assessmentSelectors).each(function(item) {
				$(this).ckeditor();

				$(this).ckeditorGet().on('instanceReady', function(e) {
					objProposal.deactivateImageDrop(this, function() {
						Backbone.trigger('form:stretch');
					});
				});

				if ($.inArray(status, ['unlaunched']) !== -1) {
					$(this).ckeditorGet().on('blur', function(e) {
						var field = (this.name).match(/field-(\w*)(-(\w*)-assessment)?/);

						proposalObject.saveField(field[1], field[3], [0], function() {
							$('.field-' + fieldId).removeClass('active');
						});
					});
				}
			});
		}
	};

	/**
	 * DEPRECATED
	 * Used in: (legacy assessments)
	 *  - apps/curriculog/webroot/js/objects/assessment.js
	 *  - apps/curriculog/views/procedures/user/proposal.single.form.html.php
	 *  - apps/curriculog/webroot/js/objects/smartfield.js
	 *  - showConflict()
	 *  - initCKEditor()
	 *  - bindAssessmentEvents()
	 */
	objProposal.saveField = function(fieldId, orderIndex, editList, callback) {
		console.log('OLD: proposal saveField');
		$('.field-' + fieldId).find('span.error.import-error').remove();
		var fieldType = $('.field-' + fieldId).attr('class').match(/type-(\w*)/)[1];

		if (fieldType != 'widget') {
			console.trace('Deprecated');
			throw Error('saveField function is deprecated');
		}

		return objAssessment.saveProposalAssessment(fieldId, orderIndex, editList);
	};

	/**
	 * DEPRECATED
	 * Used in: (legacy assessments)
	 *  - apps/curriculog/webroot/js/objects/assessment.js
	 */
	objProposal.showConflict = function(data, fieldId, orderIndex, fieldType) {
		var style = $(data).filter('#conflict-color').contents();
		$(data).filter('style').remove();

		$('#curriculog-main').append(data);
		$('style').append(style);
		var conflictId = $(data).find('input[name="conflictEditId"]').val();
		//console.log($(data).find('input[name="conflictEditId"]').val());
		//console.log(conflictId);

		var dialog = objDialog.createDOMDialog('field-conflict-dialog-'+conflictId, function(dialog, defaults) {
			// the value of the field varies:
			//    - field: field-ID
			//    - assessment: field-ID-OrderIndex-fieldType

			var conflictId = $('#conflictEditId').val();
			var fieldDomId = (orderIndex !== 0) ? '#field-' + fieldId + '-' + orderIndex + '-' + fieldType : '#field-' + fieldId;

			$('#field-conflict-value-' + conflictId).val($(fieldDomId).val());
			objProposal.initializeConflictMarkupDropdowns(conflictId);

			// Init rich-text with ckeditor
			$('textarea.ckeditor').ckeditor();

			$('textarea.ckeditor').ckeditorGet().on('instanceReady', function(e) {
				proposalObject.deactivateImageDrop(this, function() {
					Backbone.trigger('form:stretch');
				});
			});

			$('#field-conflict-diff-' + conflictId).show();

			// Actions
			defaults.buttons = {
				'Save My Changes': function() {
					// put changes into form

					$(fieldDomId).val($('#field-conflict-value-' + conflictId).val());

					// check for conflicting edits on the field
					editList = $('#conflictEditList').val().split(',');

					$(this).dialog('close');

					// save field
					proposalObject.saveField(fieldId, orderIndex, editList, function(fieldId, orderIndex, fieldType) {

						// return field to view mode
						proposalObject.editField(fieldId, 0);

					});

				},
				Cancel: function() {
					$(this).dialog('close');
					proposalObject.editField(fieldId, 0);

				}
			};

			defaults.close = function() {
				$(dialog).remove();
			};

			$(dialog).dialog(defaults);
		});
	};


	// ********************************************************************************
	// ********************************************************************************
	// ********************************************************************************
	// ***
	// ***									ACTION METHODS
	// ***
	// ********************************************************************************
	// ********************************************************************************
	// ********************************************************************************

	// METHODS included:
	//  1) saveForm (unlaunched state only)
	//  2) makeDecision (approve/reject proposal)
	//	3) changestepAction (change step action's decision field when user needs to sign a proposal)
	//	4) requestSignature (pin and upload: set the dialog and wait for user action (upload step 1))
	//  5) uploadSignature (pin and upload: set the dialog and wait for user action (upload step 2))
	//  6) enterPin (pin only: accept the pin and test, submit sig)
	//  7) closeForm (for any user not authorized to work within the proposal


	objProposal.makeDecision = function(decision, decisionFieldset) {
		var signatureNeeded = $(decisionFieldset).find('input[name="signature"]').val();

		if ( (decision === 'approve' ) && (signatureNeeded === 'true') ) {
			// When we check to see if this is approved, we'll pull it into the procedure.
			decision = 'approve-signature';
			objProposal.changeStepAction(decision, 0, decisionFieldset, function(decisionFieldset) {
				objProposal.requestSignature(decisionFieldset);
			});
		} else {
			objProposal.saveForm(decision, decisionFieldset);
		}
	};


	objProposal.changeStepAction = function(decision, sigDate, decisionFieldset, callback) {
		var proposalId = app.formView.model.id,
			currentStepId = app.formView.model.get('currentStepId');

		$.ajax({
			url: '/proposal:' + proposalId + '/paperSig.json',
			type: 'PUT',
			async: false,
			data: {
				currentStepId: currentStepId,
				stepActionId: $(decisionFieldset).find('input[name="stepActionId"]').val(),
				decision: decision,
				signature: sigDate
			},
			success: function(data) {
				if (+sigDate === 1) {
					// set decisionFieldset radio button to approve so validation doesn't fail
					var multipleDecision = $(decisionFieldset).find('input[name="multipleDecision"]').val();
					if (multipleDecision !== '0') {
						multipleDecision = '-' + multipleDecision;
					} else {
						multipleDecision = '';
					}
					$('#decision-' + decision + multipleDecision).attr('checked', true);

					objProposal.saveForm(decision, decisionFieldset);
				} else {
					if (callback) {
						callback(decisionFieldset);
					}
				}
			}
		});
	};

	/*
	 * Used in saveForm
	 */
	objProposal.validateDecision = function() {
		$.validity.start();
		$('.decision-error').assert(
			$('input[name^="make-decision"]:checked').length !== 0,
			//"You need to select a decision before you make one"
			'You need to select a decision'
		);
		var result = $.validity.end();
		return result.valid;
	};

	/*
	 * Used in saveForm()
	 */
	objProposal.checkAssessments = function(callback) {
		// make sure no assessments are empty
		var assessmentErrors = false;
		$('.widget-assessment .field-placeholder').each(function() {
			if ($(this).is('textarea') && $(this).val() === '') {
				assessmentErrors = true;

			} else if ($(this).is('div') && $(this).text() === '') {
				assessmentErrors = true;
			}

		});

		if (assessmentErrors) {
			var dialog = objDialog.createBasicWarningDialog('cannot-decide-proposal-dialog', function(dialog, defaults) {
				$(dialog).append(
					'One or more assessment fields on this proposal is ' +
					'empty. Please enter text into your assessments, or ' +
					'remove them from the proposal. Then try to make your ' +
					'decision again.'
				);

				defaults.buttons = {
					'Ok': function() {
						$(this).dialog('close');
					}
				};
				$(dialog).dialog(defaults);
			});

		} else {
			if (callback) {
				callback();
			}
		}
	};

	/**
	 * Used in saveForm
	 */
	objProposal.createCustomRoute = function(committee) {
		var proposalId = app.formView.model.id,
			currentStepId = app.formView.model.get('currentStepId');

		objDom.addLoadingMask('#decisions');
		objCustomRoute.createPendingRoute(proposalId, currentStepId, committee, function(data) {
			objCustomRoute.createDOMStep(data.stepID);
			$('#decisions').unmask();
			$('#route-comment').val($('#decision-comment').val());
		});
		Backbone.trigger('form:stretch');
	};


	/**
	 * DO NOT USE THIS
	 * This is being moved into Backbone
	 *
	 * @deprecated in favor of Backbone formView
	 */
	objProposal.saveForm = function(decision, decisionFieldset) {

		save = function() {
			// // Note: saveSmartfields doesnt actually save the smartfields to the server.
			// // It just json encodes their data and puts it in the hidden input associated
			// // with the smartfield. Then returns the entities smartfield value. BH
			// var proposalEntities = objSmartfield.saveSmartfields();
			// if (decision === 'launch' || decision === 'save') {
			// 	$('#entities').val(proposalEntities);
			// }

			$('#decision').val(decision);

			var proposalId = app.formView.model.id,
				proposalData = {
					decisionComment: $(decisionFieldset).find('textarea[name="decision-comment"]').val(),
					userId: $('input[name="user-id"]').val(),
					userName: $('input[name="user-name"]').val(),
					currentStepId: $('#currentStepId').val(),
					committeeId: $(decisionFieldset).find('input[name="decisionCommittee"]').val(),
					proposalStepActionID: $(decisionFieldset).find('input[name="stepActionId"]').val(),
					decision: decision
				};

			if (objProposal.validateDecision()) {
				// check if we are dealing with a crosslisting
				// isCrosslisted = parseInt($('input[name="crosslisted"]').val(), 10);

				$.ajax({
					url: '/proposal:' + proposalId + '/ajax/makeDecision.json',
					type: 'PUT',
					data: proposalData,
					beforeSend: function() {
						objDom.addCustomMask('#curriculog-page', 'Loading the proposal', '50');
						// if ($('#decisions').length > 0) {
						// 	objDom.addLoadingMask('#decisions');
						// } else {
						// 	objDom.addLoadingMask('body');
						// }
						// disable all form elements
						// $('.field-placeholder').attr('disabled',true);
						// $('.add-smartfield-item, .add-assessment-item').addClass('disabled');
					},
					success: function(success) {
						if (parseInt(success.data.error, 10) === 2) {
							// If the step moves on and the user is no longer involved,
							// catch a Two...... we need a better way of doing this.
							setFlashMessage({
								title: 'This proposal has moved on',
								text: 'This proposal has moved on in the workflow.',
								callback: function () {
									location.href = '/proposals';
								}
							});
							return;
						} else if (parseInt(success.data.error, 10) === 1) {
							growlError('Unauthorized',
								'The step you are making this decision on ' +
								'has moved on already. Please refresh your ' +
								'page to retrieve the newer data.'
							);
							// if ($('#decisions').length > 0) {
							// 	objDom.removeMask('#decisions');
							// } else {
							// 	objDom.removeMask('body');
							// }
							objDom.removeMask('#curriculog-page');
							return;
						}

						// Proposal has moved on (lock out additional changes and reload the page)
						// Conditions:
						// 1. If the current step ID doesn't match what the proposal previously contained
						// 2. If crosslisted proposal is complete, but waiting on others to move
						// 3. If the crosslisting has gone to review by an admin
						if (+proposalData.currentStepId !== +success.data.currentStepID ||
								success.data.status === 'waiting' || decision === 'review') {
							// disable links during growl
							$('.add-smartfield-item').on('click', function(event) {
								event.preventDefault();
							});

							setFlashMessage({
								title: 'This proposal has moved on',
								text: 'This proposal has moved on in the workflow.',
								callback: function () {
									location.reload(true);
								}
							});

							return;

						} else if (decision === 'delete') {
							// disable links during growl
							$('.add-smartfield-item').on('click', function(event) {
								event.preventDefault();
							});

							setFlashMessage({
								title: 'This proposal has been deleted',
								text: 'This proposal has been deleted from Curriculog.',
								callback: function () {
									location.href = '/proposals';
								}
							});

							return;

						} else if (success.data.status === 'completed') {
							// disable links during growl
							$('.add-smartfield-item, .add-smartfield-item').on('click', function(event) {
								event.preventDefault();
							});

							setFlashMessage({
								title: 'This proposal is complete',
								text: 'This proposal has been completed. ' +
									'There is no more work to be done on it at this time.',
								callback: function () {
									location.reload(true);
								}
							});

							return;

						} else {
							// enable all form elements
							// $('.field-placeholder').attr('disabled', false);
							// $('.add-smartfield-item, .add-assessment-item').removeClass('disabled');

							// reflect the change on the decisions tab.
							objProposal.ajaxTab('decisions');
						}

						// if ($('#decisions').length > 0) {
						// 	objDom.removeMask('#decisions');
						// } else {
						// 	objDom.removeMask('body');
						// }
						objDom.removeMask('#curriculog-page');

						Curriculog.Actions.log('proposal-decision-saved');
					}
				});
			}
		};

		switch(decision) {
		case 'launch':
			console.error('Old Launch Called! Hey you, go smack Ben upside his head because he missed a spot.');
			return;

		case 'approve':
		case 'reject':
		case 'request-hold':
		case 'request-suspend':
		case 'request-cancel':
		case 'request-route':
		case 'force-approve':
		case 'force-reject':
		case 'relaunch':
		case 'delete':
			// make sure no assessments are empty
			objProposal.checkAssessments(function() {
				save();
			});
			break;

		case 'create-route':
			var committeeId = $(decisionFieldset).find('input[name="decisionCommittee"]') ? $(decisionFieldset).find('input[name="decisionCommittee"]').val() : 0;
			objProposal.createCustomRoute(committeeId);
			break;
		case 'approve-signature':
		case 'reject-signature':
			decision = $('#decision').val().replace('-signature','');
			objProposal.changeStepAction(decision,1, decisionFieldset);
			save();
			break;
		default:
			save();
			break;
		}
	};


	/**
	 * Display a signature, using a pin
	 */
	objProposal.requestSignature = function(decisionFieldset) {
		//console.log('requestSignature');
		var dialog;

		if ($('#signature-dialog').find('input[name="user-id"]').length > 0 ){
			// First, get the decision the user is trying to make.
			var decision = ($('#decision').val() !== '') ? $('#decision').val() : $('#waitingSig').val();

			if (signatureType === 'paperSignatures') {
				dialog = objDialog.createBasicDialog('signature-paper-dialog', 'Upload Paper Signature', function(dialog, defaults) {
					$(dialog).append('In order to approve this proposal with a paper signature, you will need to complete the following steps:');
					$(dialog).append('<ol><li class="clearfix"><a href="#" class="print-icon"><img src="/images/icons/print.png" alt="Print Proposal" /></a> Print a clean proposal signature page.</li><li class="clearfix">Upload Signature.</li></ol>');

					// Actions
					defaults.buttons = {
						'Continue and Print': function() {
							$('body').removeClass('printing');
							$('#curriculog-print').remove();
							$(this).dialog('close');
							$('body').addClass('printing');
							$('#curriculog-page').append('<div id="curriculog-print" />');
							$('#curriculog-fields-column').clone().appendTo('#curriculog-print');
							$('#curriculog-print #curriculog-fields-column').attr('id','curriculog-fields-column-print');
							objProposal.appendSignatureBlock();
							window.print();
							objProposal.uploadSignature('', decisionFieldset);
						},
						Cancel: function() {
							//objProposal.changeStepAction('', 0);
							$(this).dialog('close');
						}
					};
					defaults.close = function(){
						$(this).remove();
					};

					$(dialog).dialog(defaults);
				});
			} else {
				objProposal.enterPin(decisionFieldset);
			}
		} else {
			dialog = objDialog.createBasicWarningDialog('sign-in-required', function(dialog, defaults) {
				$(dialog).append('You must be logged in to approve a proposal');
				defaults.buttons = {
					'Ok': function() {
						$(this).dialog('close');
					}
				};
				$(dialog).dialog(defaults);
			});
		}
	};

	/**
	 * Display the upload signature form
	 */
	objProposal.uploadSignature = function(signatureType, decisionFieldset) {

		if (signatureType === 'electronicPin') {
			objProposal.enterPin(decisionFieldset);

		} else {
			var decision = ($('#decision').val() !== '') ? $('#decision').val() : $('#waitingSig').val();
			var decisionText = decision.replace('-signature','');
			var dialog = objDialog.createDOMDialog('signature-upload-dialog',function(dialog, defaults) {

				$('#signature-upload-dialog').on('change', '#upload_file.error', function(event) {
					if (!validationObject.isEmpty($(this).val().trim()) &&
							validationObject.isValidExtension($(this).val().trim()) ) {
						validationObject.removeError(this, 'file-ext');
					}
				});

				defaults.buttons = {
					'Upload Signature': function() {
						// When upload form is clicked submit it by ajax.
						$('#sig_upload #s3-operation').val('upload-signature');

						// needed to do it this way so it works in Chrome, IE, and Safari
						var real = $('#signature-upload-dialog #upload_file');

						// validation
						if ( validationObject.isEmpty($(real).val().trim()) ) {
							validationObject.addError(real, 'file-ext', true, true);
						}
						if ( !validationObject.isValidExtension($(real).val().trim()) ) {
							validationObject.addError(real, 'file-ext', false, false);
						}
						if ( validationObject.hasErrors() === 0 ) {
							var realStep = $('#currentStepId');
							var cloned = real.clone(true);
							var clonedStep = realStep.clone(true);
							real.hide();
							cloned.insertAfter(real);
							realStep.hide();
							clonedStep.insertAfter(realStep);
							realStep.appendTo('#sig_upload');
							real.appendTo('#sig_upload');
							if ($('#sig_upload input[name="decisionFieldset"]').length === 0) {
								$('<input type="hidden" name="decisionFieldset" value='+ $(decisionFieldset).attr('id') +'>').appendTo('#sig_upload');
							} else {
								$('#sig_upload input[name="decisionFieldset"]').val($(decisionFieldset).attr('id'));
							}
							$(this).dialog('close');
              var s3FormData = new FormData(document.forms['sig_upload']);
              var request = new XMLHttpRequest();
              request.onload = function() {
                var decisionFieldset = $('#sig_upload').find('input[name="decisionFieldset"]').val();
                objProposal.changeStepAction('approve',1, $('#' + decisionFieldset));
              };
              request.open('POST', location.href.replace("form", "uploadSig.json"));
              request.send(s3FormData);
						}
					},
					'Print Again': function() {
						$('body').removeClass('printing');
						$('#curriculog-print').remove();
						$(this).dialog('close');
						$('body').addClass('printing');
						$('#curriculog-page').append('<div id="curriculog-print" />');
						$('#curriculog-fields-column').clone().appendTo('#curriculog-print');
						$('#curriculog-print #curriculog-fields-column').attr('id','curriculog-fields-column-print');
						objProposal.appendSignatureBlock();
						window.print();
						objProposal.uploadSignature('', decisionFieldset);
					},
					'Cancel': function() {
						objProposal.changeStepAction('', 0, decisionFieldset);
						$(this).dialog('close');
					}
				};
				defaults.close = function(){
					//$(this).remove();
				};

				$(dialog).dialog(defaults);
			});
		}
	};

	objProposal.appendSignatureBlock = function() {
		var msg = 	'<div id="approval-print">' +
						'<h3 id="approval-heading">Approval</h3>' +
						'<div id="approval-text">' +
							'This form is the official printed copy of the change proposal. ' +
							'By signing below, you acknowledge all additions and modifications herein and approve them. ' +
							'If you wish to make changes to this proposal, please use the Curriculog software. ' +
							'Any changes made to this form will not be applied to the proposal after it is uploaded. ' +
							'This form is to provide a valid approval signature only.  Once you have signed this proposal, ' +
							'please upload it back to the Curriculog website.' +
						'</div>' +
						'<div class="signature-info">Name</div>' +
						'<div class="signature-info">Title</div>' +
						'<div class="signature-info">Date</div>' +
					'</div>';
		$('#curriculog-print').append(msg);
	}

	objProposal.enterPin = function(decisionFieldset) {
		var decision = ($('#decision').val() !== '') ? $('#decision').val() : $('#waitingSig').val();

		function signature(decision, dialog) {
			var postParam = {
				id : $('#signature-dialog').find('input[name="user-id"]').val().trim(),
				pin : $('input#signature-pin').val().trim()
			};

			if (postParam.id.length > 0) {
				$.ajax({
					url: '/user/signature.json',
					type: 'get',
					data: postParam,
					success: function(result){
						if (parseInt(result.success, 10) === 1) {
							$(dialog).dialog('close');

							objProposal.changeStepAction('approve', 1, decisionFieldset);
						} else {
							$('input#signature-pin').addClass('error');
							$('#signature-error').slideDown('medium');
						}
					}
				});
			}
		}

		// What is this block for??
		if ($('#signature-pin').val() !== '') {
			// FIXME: `dialog` is being used before it is defined.
			signature(decision, dialog);
		} else {
			var dialog = objDialog.createDOMDialog('signature-dialog', function(dialog, defaults) {
				$(dialog).find('p#signature-custom-message').html('Please enter your signature pin to approve this proposal.');

				defaults.buttons = {
					'Sign': function() {
						// do ajax to see if pin was successfull
						signature(decision, dialog);
					},
					Cancel: function() {
						$('#signature-pin').val('');
						objProposal.changeStepAction('', 0, decisionFieldset);
						$(dialog).dialog('close');
					}
				};
				defaults.close = function(){
					$('input#signature-pin').removeClass('error');
					$('#signature-error').hide();
				};
				$(dialog).dialog(defaults);
			});
		}
	};


	objProposal.closeForm = function() {
		window.location.href = '/proposal';
	};

	/*
	If the field is tied to a conditional step,
	reload the steps to re-evaluate whether the step is now
	relevant to the proposal
	*/
	objProposal.conditionalRefresh = function(fieldId) {
		// radios/checkboxes keep their classes on the fieldset
		// text inputs keep their classes on the input
		if ( ($('.field-' + fieldId).hasClass('conditional')) || ($('#field-' + fieldId).hasClass('conditional'))) {
			objProposal.ajaxTab('history');
		}
	};



	objProposal.removeCrosslisting = function(id) {

		var dialog = objDialog.createBasicWarningDialog('delete-crosslisting', function(dialog, defaults) {
			// Message
			$(dialog).append('Deleting this Crosslisting will permanently remove it from Curriculog. Are you sure you want to delete this Crosslisting?');
			// Actions
			defaults.buttons = {
				'Delete Crosslisting': function() {

					$.ajax({
						url: '/proposal:' + id + '.json',
						type: 'DELETE',
						success: function(result) {
							objProposal.ajaxTab('crosslisting');
						}
					});

					$(dialog).dialog('close');
				},
				Cancel: function() {
					$(this).dialog('close');
				}
			};
			$(dialog).dialog(defaults);
		});
	};

	// How is this different than just ajaxTab('history')?
	objProposal.getUsers = function() {

		var data = {},
			proposal_id = app.formView.model.id;
		data.display = 'getUsers';

		$.ajax({
			url: '/proposal:' + proposal_id + '/ajax/getUsers',
			type: 'GET',
			data: data,
			beforeSend: function() {
				if (! $('#curriculog-fields-column').hasClass('full-width')) {
					objDom.addMask('.steps','Updating');
				}
				objProposal.destroyStatusBindings();
			},
			complete: function() {
				if (! $('#curriculog-fields-column').hasClass('full-width')) {
					objDom.removeMask('.steps');
				}
			},
			success: function(result) {
				// Put steps into DOM
				$('#history .steps').contents().remove();
				$('#history .steps').append(result);

				// rebind
				objProposal.initStatusBindings();
				Backbone.trigger('form:stretch');

				// getUsers is a strange name for a function that loads steps
				Curriculog.Actions.log('proposal-steps-loaded');
			}
		});
	};

	/**
	 *  Used in:
	 *   - js/objects/import.js
	 */
	objProposal.resetCurriculum = function(canEdit, richText, view) {
		// FIXME Don't hack.
		resetCurriculum(canEdit, richText);

		// HACK: Set timeout here because the render has to finish before
		// we can trigger showSchema()
		setTimeout(function() {
			if (view === 'schema') {
				app.cv.showSchema();
			} else {
				app.cv.showCourses();
			}
		}, 2000);

	};


	/**
	 *
	 * Used in:
	 *  - proc/user/proposal.single.map.html.php
	 *  - js/objects/assessment.js
	 */
	objProposal.getMapType = function(showMarkup) {
		// Next, get appropriate view and ajax into place
		data = {};
		data.display = 'popupMap';
		data.userId = $('#user').val();
		data.mapType = $('#curriculum-map-types').val();
		data.showMarkup = (showMarkup !== undefined) ? showMarkup : 0;

		$.ajax({
			url: '/proposal:'+ $('#proposalId').val() +'/map',
			type: 'GET',
			data: data,
			beforeSend: function() {
				objDom.addLoadingMask('#curriculog-fields-column-content');
				if ($('#curriculum-map-types option').length === 0) {
					objProposal.getMaps('curriculum-map-types');
				}
			},
			success: function(result) {

				var makeActive = true;
				// if the map extend is not active then hide the data
				if ($('#curriculog-map-expand').hasClass('active')) {
					makeActive = true;
				} else {
					makeActive = false;
				}

				objDom.removeMask('#curriculog-fields-column-content');
				//console.log(result);
				var content = $(result).find('.map').contents();
				$('#curriculog-fields-column-content .map').html(content);

				// if the map extend is not active then hide the data
				//objProposal.expandMapAssessments();
				if (makeActive) {
					$($('.map tbody tr:not(.course)')).show();
					$('#curriculog-map-expand').addClass('active');

				} else {
					$($('.map tbody tr:not(.course)')).hide();
					$('#curriculog-map-expand').removeClass('active');
				}
			}
		});
	};


	// ********************************************************************************
	// ********************************************************************************
	// ********************************************************************************
	// ***
	// ***								MAP METHODS
	// ***
	// ********************************************************************************
	// ********************************************************************************
	// ********************************************************************************


	/**
	 * Used in:
	 *  - proc/user/proposal.single.map.html.php
	 */
	objProposal.expandMapAssessments = function() {
		if ($('#curriculog-map-expand').hasClass('active')) {
			$($('.map tbody tr:not(.course)')).hide();
			$('#curriculog-map-expand').removeClass('active');
		} else {
			$($('.map tbody tr:not(.course)')).show();
			$('#curriculog-map-expand').addClass('active');
		}
	};

	/**
	 * Used in:
	 *  - here... js/objects/form/proposal.js
	 *  - proc/user/proposal.single.map.html.php
	 */
	objProposal.getMaps = function(selectId) {
		$.get('/setting/AssessmentMap.json', '', function(data) {
			$('#' + selectId).contents().remove();
			$.each(data.setting, function(index, map) {
				$('<option value="'+ map.id +'">'+ map.name +'</option>').appendTo($('#' + selectId));
			});
		});
	};


	// Alias assessment methods
	// objProposal.saveAssessments = objAssessment.saveProposalAssessments;
	objProposal.saveMapAssessment = objAssessment.saveMapAssessment;
	objProposal.getProposalAssessment = objAssessment.getProposalAssessment;

	/**
	 * Used in:
	 *  - proc/user/proposal.single.form.html.php
	 *  - proc/user/proposal.single.map.html.php
	 */
	objProposal.saveMapOption = function(obj) {
		if ($(obj).is(':checked')) {
			$(obj).attr('checked', true);
		} else {
			$(obj).attr('checked', false);
		}

		if ($('.map').length > 0) {

			var item = {
				inventoryID: $(obj).closest('td').find('input[name="inventoryID"]').val(),
				proposalAssessmentID: $(obj).closest('td').find('input[name="assessmentID"]').val(),
				outcomeID: $(obj).closest('td').find('input[name="outcomeID"]').val(),
				proposalID: $('#proposalId').val(),
				value: $(obj).val(),
				mapType: $('#curriculum-map-types').val()
			};

			var url = '';
			var type = 'add';
			if ($(obj).is(':checked')) {
				url = '/assessment:'+ $('#proposalId').val() +'/addMapOption.json';
			} else {
				url = '/assessment:'+ $('#proposalId').val() +'/removeMapOption.json';
				type = 'remove';
			}

			var data = {};
			data.item = item;

			$.ajax({
				url: url,
				type: 'PUT',
				data: data,
				beforeSend: function() {
					objDom.addMask($(obj).parents('td'));
				},
				success: function(data) {
					objProposal.updateOptionLabel(obj,$(obj).next('label').html(), type);
					objDom.removeMask($(obj).parents('td'));
				}
			});
		}
	};

	/**
	 * Used in:
	 *  - here... right up there ^^^^^^^^^^^^^
	 */
	objProposal.updateOptionLabel = function(option, label, type) {
		var optionIndex = $(option).parents('td').index();
		var parentTRClass = $(option).closest('td').parent('tr').attr('class');
		var matrixTD = $(option).closest('td').parent('tr').parents('tbody').find('.' + parentTRClass + '.course');


		var labels = {};
		var parentTR = $(option).closest('td').parent('tr').parents('tbody').find('.' + parentTRClass);

		$(parentTR).each(function(tr) {
			$($(this).children()[optionIndex]).children('div').children('div').children('input:checkbox').each(function(index) {
				labels[$(this).next('label').html()] = 0;
			});
		});

		$(parentTR).each(function(tr) {

			$($(this).children()[optionIndex]).children('div').children('div').children('input:checkbox').each(function(index) {
				if ($(this).is(':checked')) {
					labels[$(this).next('label').html()] = 1;
				}
			});
		});

		var title = matrixTD.children()[optionIndex];
		var html = $(title).find('.assessment-data').text();

		if (html === null) {
			html = [];
		} else {
			html = html.split(',');
		}

		$.each(html, function(index, val) {
			html[index] = $.trim(val);
		});

		// reset labels for those not clicked
		$.each(labels, function(labelTxt, value) {
			if (parseInt(value, 10) === 0) {
				if ($.inArray(labelTxt, html) !== -1) {
					if (html === labelTxt) {
						html = '';
						$(title).find('.assessment-data').text(html);
						$(title).find('.export-data').text(html);

					} else {
						for (var i = 0; i < html.length; i++) {
							if (html[i] === labelTxt) {
								html.splice(i, 1);
								html = html.join(', ');
							}
						}

						$(title).find('.assessment-data').text(html);
						$(title).find('.export-data').text(html);
					}
				}
			}
		});

		if (labels[label] === 0) {
			return;
		}

		if ($.inArray(label, html) !== -1) {
			return;

		} else {
			// because  html has one empty item, it will always need to be joined and tested for emptiness
			if (html.length === 0 || html.join('') === '') {
				$(title).find('.assessment-data').text(label);
				$(title).find('.export-data').text(label);
				//$(title).html(label);
			} else {
				//$(title).html(html + ',' + label);
				$(title).find('.assessment-data').text(html.join(', ') + ', ' + label);
				$(title).find('.export-data').text(html + ', ' + label);
			}
		}
	};


	// ********************************************************************************
	// ********************************************************************************
	// ********************************************************************************
	// ***
	// ***							TRACKING METHODS
	// ***
	// ********************************************************************************
	// ********************************************************************************
	// ********************************************************************************

	/**
	 * Used in:
	 *  - proc/user/proposal.single.form.html.php
	 */
	objProposal.trackItem = function(itemId, itemSubId, itemType) {
		/*
			used when individual widget items are clicked after field is active,
			to create the base record for the item with the subItemId
		*/

		var dataParams = {
			step: app.formView.model.get('currentStepId'),
			itemId: Number(itemId),
			itemSubId: Number(itemSubId),
			user: app.formView.model.get('user'),
			itemType: itemType,
			originalValue: $('#field-' + itemId + '-' + itemSubId + '-' + itemType).val()
		};

		$.ajax({
			url: '/proposalTracking:' + app.formView.model.id + '/save.json',
			type: 'PUT',
			data: dataParams,
			success: function(data) {}
		});
	};

	/**
	 * Used in:
	 *  - pageTemplates/user/proposalPrint.html.php
	 *  - showMarkupForPrint()
	 */
	objProposal.initSelect2ForPrint = function() {
		var fields = $('.type-smartfield:not(.prospectiveCurriculum) .field-placeholder');
		fields.selectWoo({
			theme: 'curriculog',
			disabled: true
		});
		fields.on('select2:opening', function(){
			return false;
		});
	};

	/**
	 * Used in:
	 *  - pageTemplates/user/proposalPrint.html.php
	 */
	objProposal.showSectionsForPrint = function(pageBreak) {

		var optionCount = $('.print-option:not(#tracking):checked').length;

		// add a page break after the form
		if (optionCount > 0 && pageBreak) {
			$('#curriculog-content').append('<div class="page-break"></div>');
		}

		// turn on selected print options
		$('.print-option:checked').each(function(index, option) {
			$('.' + $(option).val()).show();
			if ((index < optionCount - 1) && pageBreak) {
				$('.' + $(option).val()).append('<div class="page-break"></div>');
			}
		});

		// comment children
		if ($('#comments').is(':checked')) {
			$('#comments-list').find('.comment.child').each(function() {
				$(this).addClass('active');
			});
		}

	};

	/**
	 * Used in:
	 *  - pageTemplates/user/proposalPrint.html.php
	 */
	objProposal.showMarkupForPrint = function(status, callback) {

		data = {
			display: 'getFormPrint',
			userId: 0,
			mapType: '',
			showMarkup: 0
		};

		$.ajax({
			url: '/proposal:'+ $('#proposalId').val() +'/ajax/viewForm',
			type: 'GET',
			data: data,
			async:false,
			beforeSend: function() {
				objDom.addLoadingMask('#curriculog-content');
			},
			success: function(result) {
				objDom.removeMask('#curriculog-fields-column-content');
				$('#curriculog-fields-column-content').html(result);
				//objProposal.switchFieldsetWithDiv();

				objProposal.initSelect2ForPrint();

				// curriculum preview
				if ($('#proposalType').val() === 'program'){
					var options = {
						proposalID: $('#proposalId').val(),
						richText: $('#curriculumRichText').val()
					};

					cm = new Curriculog.Curricula(options);
					cmView = new Curriculog.CurriculumPreview({collection: cm});
					$('.prospectiveCurriculum .field-placeholder').replaceWith(cmView.el);
					objProposal.switchFieldsetWithDiv();
					objDom.removeMask('#curriculog-content');
					callback && callback();

				} else {
					objProposal.switchFieldsetWithDiv();
					objDom.removeMask('#curriculog-content');
					callback && callback();
				}
			}
		});

	};

	/**
	 * Used in:
	 *  - pageTemplates/user/proposalPrint.html.php
	 */
	objProposal.showMarkupForPrintSummary = function(showMarkup, summary, callback) {

		// Used to print the entire proposal with markup or just the summary fields

			data = {
			display: 'getFormAndUsers',
			userId: 1,
			mapType: 0,
			showMarkup: false
		};


		if(showMarkup & summary){
			url = '/proposalTracking:' + $('#proposalId').val() + '/trackSummaryEditsDiff';
		}else if(showMarkup){
			url = '/proposalTracking:' + $('#proposalId').val() + '/trackEditsDiff';
		}

		$.ajax({
			url: url,
			type: 'GET',
			data: data,
			beforeSend: function() {
				objDom.addLoadingMask('#curriculog-content');
			},
			success: function(result) {

				var form = $(result).filter('#form');
				var files = $(result).filter('#files').html();
				var styles = $(result).filter('#editor-styles').html();


				// form
				$('#curriculog-fields-column-content').html(form);

				objProposal.initSelect2ForPrint();

				// files
				$('#files-content-markup').html(files);

				// styles
				$('#editor-styles').append(styles);
				$('fieldset.section-fieldset').addClass('proposal-page'); // needed to get the colors to appear

				// curriculum preview
				if ($('#proposalType').val() === 'program'){
					var options = {
						proposalID: $('#proposalId').val(),
						richText: $('#curriculumRichText').val(),
						active: false,
						edits: false
					};

					cm = new Curriculog.Curricula(options);
					cmView = new Curriculog.CurriculumPreview({collection: cm});
					$('.prospectiveCurriculum .field-placeholder').replaceWith(cmView.el);
					$('.curriculog-agenda-print').addClass('diff');
					objProposal.switchFieldsetWithDiv();
					objDom.removeMask('#curriculog-content');
					callback && callback();

				} else {
					objProposal.switchFieldsetWithDiv();
					objDom.removeMask('#curriculog-content');
					callback && callback();
				}
			}
		});


	};


	/**
	 * Used in:
	 *  - pageTemplates/user/proposalPrint.html.php
	 */
	objProposal.printSummary = function(callback) {

		// Used to print the entire proposal with markup or just the summary fields
		data = {
				display: 'getFormPrint',
				userId: 0,
				mapType: '',
				showMarkup: 0,
				mode:'preview'
			};

			$.ajax({
				url: '/proposal:'+ $('#proposalId').val() +'/ajax/viewSummary',
				type: 'GET',
				data: data,
				async:false,
				beforeSend: function() {
					objDom.addLoadingMask('#curriculog-content');
				},
				success: function(result) {
					objDom.removeMask('#curriculog-fields-column-content');
					$('#curriculog-fields-column-content').html(result);

					objProposal.initSelect2ForPrint();

					// curriculum preview
					if ($('#proposalType').val() === 'program'){
						var options = {
							proposalID: $('#proposalId').val(),
							richText: $('#curriculumRichText').val()
						};

						cm = new Curriculog.Curricula(options);
						cmView = new Curriculog.CurriculumPreview({collection: cm});
						$('.prospectiveCurriculum .field-placeholder').replaceWith(cmView.el);
						objProposal.switchFieldsetWithDiv();
						objDom.removeMask('#curriculog-content');
						callback && callback();

					} else {
						objProposal.switchFieldsetWithDiv();
						objDom.removeMask('#curriculog-content');
						callback && callback();
					}
				}
			});
	};

	/**
	 * Used in:
	 *  - here, throughout the print functions
	 */
	objProposal.switchFieldsetWithDiv = function() {
		// replace all fieldsets with divs to bypass the FF printing bug
		$('fieldset.section').replaceWith(function() {
			return $("<div />").addClass($(this).attr('class')).attr('id', $(this).attr('id')).append($(this).contents());
		});
		$('fieldset.section-fieldset').replaceWith(function() {
			return $("<div />").addClass($(this).attr('class')).append($(this).contents());
		});
	};

	/**
	 * Used in:
	 *  - js/curriculum.js
	 */
	objProposal.initMarkupTooltips = function() {
		$('.qtip .edit-tooltip').closest('.qtip').remove();
		$('.edit-tip').each(function(){
			var editId = $(this).attr('class').match(/(edit-\d*)/)[1];
			if ( $('.edit-tooltip.' + editId).hasClass('active') ) {
				$(this).qtip({
					content: $('.edit-tooltip.active.' + editId).first().clone(),
					show: {ready: false},
					style: {tip: true}
				});
			}
		});
	};

	/**
	 * Used in:
	 *  - js/curriculum.js
	 */
	objProposal.initCKEditor = function (scopedItem) {
		var $scopedItem = $(scopedItem);
		$scopedItem.ckeditor();
		$scopedItem.each(function() {
			var cke = $(this).ckeditorGet();

			cke.on('instanceReady', function (event) {
				objProposal.deactivateImageDrop(this);
				Backbone.trigger('form:stretch');
			});

			cke.on('blur', function (event) {
				var field = (this.name).match(/field-(\w*)(-(\w*)-assessment)?/);
				if (field !== null) {
					var fieldId = field[1];
					var widgetId = (field[3] !== undefined) ? field[3] : 0;
					var input = $('#field-' + fieldId);

					objProposal.validate(input, event);
					var invalidInput = $('#field-' + fieldId).hasClass('error');

					var isDirty = cke.checkDirty(); // Have there been changes since the last save?
					if (!invalidInput && isDirty) {
						objProposal.saveField(fieldId, widgetId, [0], function () {
							$('.field-' + fieldId).removeClass('active');
						});
						cke.resetDirty();
					}
				}
			});
		});
	};


	// ********************************************************************************
	// ********************************************************************************
	// ********************************************************************************
	// ***
	// ***								WORK METHODS
	// ***
	// ********************************************************************************
	// ********************************************************************************
	// ********************************************************************************


	// ********************************************************************************
	// ********************************************************************************
	// ********************************************************************************
	// ***
	// ***									WORK:
	// ***								COMMENT METHODS
	// ***
	// ********************************************************************************
	// ********************************************************************************
	// ********************************************************************************

	/*
	 * Used in:
	 * 	  here: ajaxTab()
	 *     - pageTemplates/user/proposalPrint.html.php
	 *     - proc/user/proposal.single.form.html.php
	 */
	objProposal.getComments = function(){
		$.ajax({
			url: '/comment.json?proposalId=' + $('#curriculog-proposal input[name="proposalId"]').val(),
			type: 'get',
			success: function (result) {

				$('#comments-list').empty();

				if (result.comments !== undefined && result.comments.length > 0) {
					$.each(result.comments, function(index, comment) {
						var commentId = comment.id;
						var commentAddedDate = objDate.convertFromIso(comment.created.scalar);
						var user = DOMPurify.sanitize(comment.user);
						var commentTemplate = $('#comment-template li').clone(true).attr('id', 'comment-' + commentId);

						if (comment.systemComment){
							$(commentTemplate).addClass('systemComment');
							$(commentTemplate).find('.comment-title strong').html('Modern Campus Curriculum');
						} else {
							$(commentTemplate).find('.comment-title strong').html(user);

							if (comment.editColor !== '') {
								$(commentTemplate).find('.comment-title .user-color').addClass('user-' + comment.userId)
									.attr('style','background:' + comment.editColor);
							}
						}

						$(commentTemplate).find('.comment-date').html(commentAddedDate);
						$(commentTemplate).find('.comment-content').html(DOMPurify.sanitize(comment.comment.replace(/\n/g, '<br />')));

						$('#comments-list').prepend(commentTemplate).find('li:first').fadeIn(300);

						$.each(comment.children, function(index2, commentChild) {
							var commentChildTemplate = $('#comment-template li').clone(true).attr('id', 'comment-' + commentChild.id).addClass('child');

							if ($('#comments-list #comment-' + commentId).find('ul').size() === 0) {
								$('#comments-list #comment-' + commentId).append('<ul></ul>');
								var links = $('#comments-list #comment-' + commentId).addClass('has-replies').find('.comment-links');
								if ($(links).children('a').size() > 0) {
									$(links).prepend(' | ');
								}
								$(links).prepend('<a href="#" class="view-replies"></a>');
							}
							var childList = $('#comments-list #comment-' + commentId).find('ul');

							commentAddedDate = objDate.convertFromIso(commentChild.created.scalar);
							user = commentChild.user;

							$(commentChildTemplate).find('.comment-title strong').html(user);
							if (commentChild.editColor !== '') {
								$(commentChildTemplate).find('.comment-title .user-color').attr('style','background:' + commentChild.editColor);
							}
							$(commentChildTemplate).find('.comment-date').html(commentAddedDate);
							$(commentChildTemplate).find('.comment-content').html(DOMPurify.sanitize(commentChild.comment.replace(/\n/g, '<br />')));
							$(commentChildTemplate).find('.comment-links').html('');

							$(childList).append(commentChildTemplate);
							var numberOfReplies = $('#comments-list #comment-' + commentId).find('li').size();
							if (numberOfReplies === 1) {
								$('#comments-list #comment-' + commentId).addClass('has-replies').find('.view-replies').text(numberOfReplies + ' Reply');
							} else {
								$('#comments-list #comment-' + commentId).addClass('has-replies').find('.view-replies').text(numberOfReplies + ' Replies');
							}
						});

					});

				} else {
					if ($('#comments-list .no-comments').length === 0) {
						$('#comments-list').append('<li class="no-comments">There are no comments available for this proposal.</li>');
					}
				}

				$('#comments div.loading').hide();
				if ($('.curriculog-agenda-print').length === 0) {
					Backbone.trigger('form:stretch');
				}
			}
		});

	};

	/**
	 *  Used in:
	 *   - initCommentBindings()
	 */
	objProposal.showReplies = function(commentId){
		if ($('#comments-list #comment-' + commentId).find('.comment.child').hasClass('active')) {
			$('#comments-list #comment-' + commentId).find('.comment.child').removeClass('active');
		} else {
			$('#comments-list #comment-' + commentId).find('.comment.child').addClass('active');
		}

		Backbone.trigger('form:stretch');
	};

	/**
	 *  Used in:
	 *   - initCommentBindings()
	 */
	objProposal.addCommentDialog = function() {
		// pull up dialog box with form to add comment and list of comments
		var dialog = objDialog.createDOMDialog('comment-dialog', function(dialog, defaults) {
			dialog.addClass('add-comment').removeClass('reply-comment');

			$('#comment-fieldset').find('input[name="reply-to"]').attr('value', '');

			// Actions
			defaults.buttons = {
				'Add Comment': function() {
					objProposal.addComment(dialog);
					$(this).dialog('close');
				},
				Cancel: function() {
					$(this).dialog('close');
					$('#comment').val('');
				}
			};
			$(dialog).dialog(defaults);
		});
	};

	/**
	 *  Used in:
	 *   - replyToCommentDialog()
	 *   - addCommentDialog()
	 */
	objProposal.addComment = function(dialog){

		// grab comment and make a buble under "Comments"
		var commentFieldset = $('#comment-fieldset');
		var comment = $(dialog).find('textarea[name="comment"]').val();

		// ajax
		var commentData = {
			'userId' : $(commentFieldset).find('input[name="user-id"]').val().trim(),
			'comment' : comment,
			'replyId' : $(commentFieldset).find('input[name="reply-to"]').val().trim(),
			'editId' : '',
			'proposalId' : $('#curriculog-proposal input[name="proposalId"]').val(),
			'currentStepId' : $('#currentStepId').val()
		};

		if (commentData.replyId.length > 0 ) {
			var parentId = commentData.replyId;
			if ($('#comments-list #comment-' + parentId).find('ul').size() === 0) {
				$('#comments-list #comment-' + parentId).append('<ul></ul>');
				$('#comments-list #comment-' + parentId).addClass('has-replies').find('.comment-links').prepend('<a href="#" class="view-replies"></a> | ');
			}
			$('#comments-list #comment-' + parentId).find('ul').prepend('<li class="waiting"></li>');
		} else {
			$('#comments .loading:first').show();
		}

		$.ajax({
			url: '/comment:' + commentData.proposalId + '.json?proposalId=' + commentData.proposalId,
			type: 'POST',
			data: commentData,
			success: function(result){
				if (parseInt(result.success, 10) === 1) {
					var commentId = result.id;
					var commentAddedDate = objDate.convertFromIso(result.created.scalar);
					var user = $(commentFieldset).find('input[name="user-name"]').val().trim();
					var commentTemplate = $('#comment-template li').clone(true).attr('id', 'comment-' + commentId);

					$(commentTemplate).find('.comment-title strong').html(user);
					$(commentTemplate).find('.comment-title .user-color').addClass('user-' + result.userId);
					// console.log(result.editColor);
					if (result.editColor !== '') {
						$(commentTemplate).find('.step-title .user-color').attr('style', 'background:' + result.editColor);
					}

					$(commentTemplate).find('.comment-date').html(commentAddedDate);
					$(commentTemplate).find('.comment-content').html(DOMPurify.sanitize(comment.replace(/\n/g, '<br />')));

					// Remove the bubble that says there are no comments
					$('#comment-0, .no-comments').remove();

					// add comment to list
					if (commentData.replyId.length > 0 ) {
						$(commentTemplate).addClass('child').find('.comment-links').html('');
						var childList = $('#comments-list #comment-' + parentId).find('ul');
						$(childList).prepend(commentTemplate);
						$(childList).find('li.waiting').remove();
						var numberOfReplies = $('#comments-list #comment-' + parentId).find('li').size();
						if (numberOfReplies === 1) {
							$('#comments-list #comment-' + parentId).addClass('has-replies').find('.view-replies').text(numberOfReplies + ' Reply');
						} else {
							$('#comments-list #comment-' + parentId).addClass('has-replies').find('.view-replies').text(numberOfReplies + ' Replies');
						}
						$('#comment-' + parentId).find('.comment.child').addClass('active');
						$('.scrollable').stop().scrollTo( $('#comments-list #comment-' + parentId), 500 );
					} else {
						$('#comments-list').prepend(commentTemplate);

						$('.scrollable').stop().scrollTo( $('#comments-list li:first'), 500 );
					}

					// clean up the comment form
					//$(dialog).find('textarea[name="comment"]').attr('value', '');
					$('#comment').val('');

					$(commentFieldset)
						.find('button[name="add-comment"]')
						.text('Add Comment')
						.siblings('input[name="reply-to"]')
						.attr('value', '');
					Backbone.trigger('form:stretch');
					// objProposal.scrollLinksReset();

					// Make sure history says there are comments
					$('#step-'+$('#currentStepId').val() + ' .activity .activity-comments').text('Yes');
				}

				$('#comments-list .comment').removeClass('highlight');
				$('#comments div.loading').hide();
				$('#comments-list li.waiting').remove();

				if (result.success !== 1) {
					var dialog = objDialog.createBasicWarningDialog('add-comment-failed', function(dialog, defaults) {
						// Message
						$(dialog).append('An error has occurred. Comment was not saved.');
						// Actions
						defaults.buttons = {
							'Ok': function() {
								$(this).dialog('close');
							}
						};

						$(dialog).dialog(defaults);

					});
				} else {
					Curriculog.Actions.log('proposal-comment-added');
				}
			}
		});

	};

	/**
	 *  Used in:
	 *   - initCommentBindings()
	 */
	objProposal.replyToCommentDialog = function(commentId) {
		$('#comments-list #comment-' + commentId).addClass('highlight');

		// pull up dialog box with form to add comment and list of comments
		var dialog = objDialog.createDOMDialog('comment-dialog', function(dialog, defaults) {
			defaults.width = 800;
			dialog.addClass('reply-comment').removeClass('add-comment');


			var comment = $('#comment-' + commentId).clone(true).attr('id', 'comment-' + commentId + '-dialog');

			$(comment).find('ul li').each(function(index, dialogCommentLi){
				$(dialogCommentLi).attr('id', dialogCommentLi.id + '-dialog').find('div.bubble').show();
			});

			var liStep = '';
			if ($(comment).find('ul li').size() > 0) {
				liStep = ' has-replies';
			}

			var numberOfReplies = $(comment).find('ul li').size();
			if (numberOfReplies === 1) {
				$(comment).find('.comment-links:first').html(numberOfReplies + ' Reply');
			} else {
				$(comment).find('.comment-links:first').html(numberOfReplies + ' Replies');
			}

			var commentHtml = '<h3>You are replying to this comment:</h3>' +
								'<div class="vertical" style="height: 200px">' +
								'<ul id="dialog-comments-list" class="comments">' +
								'<li class="comment' + liStep + '">' + $(comment).html() + '</li>' +
								'</ul></div>';

			$(dialog).find('div.right').html(commentHtml);

			$('#comment-fieldset').find('input[name="reply-to"]').val(commentId);


			// Actions
			defaults.buttons = {
				'Reply to Comment': function() {
					objProposal.addComment(dialog);
					$(this).dialog('close');
				},
				Cancel: function() {
					$('#comments-list #comment-' + commentId).removeClass('highlight');
					$(this).dialog('close');
					$('#comment').val('');
				}
			};

			$(dialog).dialog(defaults);
		});

		Backbone.trigger('form:stretch');
	};

	// ********************************************************************************
	// ********************************************************************************
	// ********************************************************************************
	// ***
	// ***							VALIDATION METHODS
	// ***
	// ********************************************************************************
	// ********************************************************************************
	// ********************************************************************************

	/**
	 * Used in:
	 *  - initDecisionBindings()
	 *  - initCKEditor()
	 *  - assessment field save event handler:
	 *  	- apps/curriculog/views/procedures/user/proposal.single.form.html.php
	 */
	objProposal.validate = function(input, event, type) {
		var elementValue = $.trim($(input).val());

		var valid = false;
		var required = false;
		var inputType = objValidation.getInputType(input);
		if (inputType === 'textarea') {
			type = '';
		}

		switch (inputType) {
		case 'checkbox':
		case 'radio':
		case 'smartfield':
			if ($(input).parents('fieldset:first').hasClass('required')) {
				if (inputType === 'smartfield') {
					if ($(input).siblings('.smartfield-item').length < 1){
						required = true;
					}
				} else {
					if ( $(input).parents('fieldset:first').find('input:checked').size() < 1) {
						required = true;
					}
				}
			}
			type = '';
			valid = true;
			break;
		default:
			if ($(input).hasClass('required')) {
				if ( objValidation.isEmpty(elementValue) ) {
					required = true;
				}
			}

			if (typeof type === 'undefined') {
				type = '';
				var tempType = $(input).attr('class').match(/validate-(numeric|alpha|email|phone|date)/);
				if (tempType && tempType[1] !== undefined) {
					type = tempType[1].toLowerCase();
				}
			}

			// type of validation
			switch (type) {
			case 'numeric':
				if (objValidation.isInteger(elementValue)) {
					valid = true;
				}
				break;
			case 'alpha':
				if (objValidation.isAlpha(elementValue)) {
					valid = true;
				}
				break;
			case 'email':
				if (objValidation.isEmail(elementValue)) {
					valid = true;
				}
				break;
			case 'phone':
				if (objValidation.isPhone(elementValue)) {
					valid = true;
				}
				break;
			case 'date':
				if (objValidation.isDate(elementValue)) {
					valid = true;
				}
				break;
			default:
				valid = true;
				break;
			}
			break;
		}

		return objValidation.updateForm(input, valid, required, type, function(){
				$(input).parents('fieldset:first').removeClass('error');
				Backbone.trigger('form:stretch');
			}, function(){
				$('#curriculog-steps-column-decisions')
					.find('button')
					.removeAttr('disabled')
					.fadeTo('fast', 1.0);
			}, function(){
				$('#curriculog-steps-column-decisions')
					.find('button')
					.attr('disabled', 'disabled')
					.fadeTo('fast', 0.5);
			});

	};

	// ********************************************************************************
	// ********************************************************************************
	// ********************************************************************************
	// ***
	// ***						HELPER AND PRIVATE FUNCTIONS
	// ***
	// ********************************************************************************
	// ********************************************************************************
	// ********************************************************************************

	/**
	 * Used in:
	 *  - initStatusBindings()
	 */
	objProposal.openStepLog = function(step) {
		var stepId = $(step).closest('.step').attr('id').match(/step-(\d*)/);

		$.ajax({
			url: '/proposalStep:' + stepId[1] + '/getStepLog',
			type: 'GET',
			data: {display:'stepLog', user: $('#user').val()},
			beforeSend: function() {
				objDom.addLoadingMask('#' + stepId[0]);
			},
			success: function(data) {
				objDom.removeMask('#' + stepId[0]);

				$('body').append(data);

				var dialog = objDialog.createDOMDialog('step-log-dialog', function(dialog, defaults) {
					// Actions

					defaults.buttons = {
						'Close': function() {
							$(this).dialog('close');
						}
					};
					// Cleanup
					defaults.close = function() {
						$('#step-log-dialog').remove();
					};
					$(dialog).dialog(defaults);
				});

			}
		});
	};

	/**
	 * Used in:
	 *  - js/objects/list/agenda.js@initRichText
	 *  - editField()
	 *  - bindAssessmentEvents()
	 *  - showConflict()
	 *  - initCKEditor()
	 */
	objProposal.deactivateImageDrop = function(editor, callback) {
		editor.document.on('drop', function(e) {
			e.data.preventDefault(true);
		});

		callback && callback();
	};

	objProposal.initCrosslistingBindings = function() {

		$('#curriculog-steps-column').on('click','#add-crosslisting-course', function(e) {
			e.preventDefault();

			var proposalId = app.formView.model.id,
				apId = app.formView.model.get('approvalProcessId'),
				user = app.formView.model.get('user');

			$.ajax({
				url: '/proposal:' + proposalId + '/crosslisting.json',
				type: 'POST',
				data: {apId: apId, userId: user},
				beforeSend: function() {
					objDom.addMask('#crosslisting');
				},
				success: function(data) {
					objDom.removeMask('#crosslisting');
					proposalObject.ajaxTab('crosslisting');
					app.formView.model.set({crosslisted: 1});
				}
			});
		});

		$('#curriculog-steps-column').on('click','.select-crosslisting', function(e) {
			e.preventDefault();
			location.href = '/proposal:' + $(this).parents('li').attr('id').replace('crosslisting-','') + '/form';
		});

		$('#curriculog-steps-column').on('click','.crosslisting-remove', function(e) {
			e.preventDefault();
			var crosslistingId = $(this).parents('li').attr('id').replace('crosslisting-','');
			proposalList().confirmDeleteProposal(crosslistingId, 'hard');
		});
	};

	objProposal.initProposalLookupBindings = function() {
		var decodeHTMLEntities = function (html) {
			var txt = document.createElement('textarea');
			txt.innerHTML = html;
			return txt.value;
		};

		var proposalId = app.formView.model.id;
		var proposalName = decodeHTMLEntities(app.formView.model.get('proposalName').replace(/ -  - /, ""));
		var params = _.extend({}, app.params, {proposalId: proposalId, proposalName: proposalName});
		app.proposalLookupView = new Curriculog.ProposalToolbox.ProposalLookup({collection: app.proposals, user: app.user, params: params});
		$('#proposal-lookup-search-keyword').val(proposalName);
		app.proposalLookupView.search();

		// Actions: focus-within css workaround for IE
		var previousListColumnResult;
		$('#proposal-lookup-list-column-results-content').on('focus','.proposal-lookup-summary', function(){
				$(this).addClass('focus-within');
				var currentListColumnResult = $(this).closest('.proposal-lookup-summary').attr('id');
				if ( previousListColumnResult !== null && previousListColumnResult !== currentListColumnResult ){
						$('#' + previousListColumnResult).removeClass('focus-within');
						previousListColumnResult = currentListColumnResult;
				}
		});
		$('#proposal-lookup-list-column-results-content').on('blur','.proposal-lookup-summary', function(event){
				if ($(event.relatedTarget).parents('#proposal-lookup-list-column-results-content').length === 0 ){
					$('#' + previousListColumnResult).removeClass('focus-within');
					if ($(event.currentTarget).hasClass('proposal-lookup-summary') === false ){
							previousListColumnResult = null;
					}
				}
		});
	};


	objProposal.initRouteBindings = function() {
		$('body').on('click', '#request-custom-route', function(event) {
			event.preventDefault();

			$.validity.start();
			$('#route-comment').require().assert(function(){
				// disallow whitespace only comments
				return $('#route-comment').val().trim().length > 0;
			}, "Comment is required.");
			$('.step-name-input').require().assert(function(){
					return $('.step-name-input').val().trim().length > 0;
			}, "Step name is required.");
			var results = $.validity.end();

			$(this).parent().siblings('.js-unsaved-error').remove();
			if (app.formView.hasUnsavedChanges()) {
				var err = $('<span class="error js-unsaved-error">The proposal has unsaved changes. Please save or cancel these changes before continuing.</span>');
				err.insertBefore($(this).parent());
			}

			if (!results.valid) {
				return;
			}

			if ($('#route input.error, #route textarea.error, .js-unsaved-error').size() < 1){
				customRouteObject.launchPendingRoute();
			} else {
				Backbone.trigger('form:stretch');
			}

		});

		$('body').on('click', '#preview-custom-route', function(event) {
			event.preventDefault();
			event.stopPropagation();

			// togglePendingRoute takes two callbacks, previewCallback and editCallback
			// which use the same button to load the preview and the edit view of the
			// custom route.
			var previewCallback = function() {
				Backbone.trigger('form:stretch');
			};

			var editCallback = function() {
				// due to callback hell, I am setting this into global scope.
				// when backbone comes, clean this up.
				routeComment = $('#route-comment').val();
				objProposal.ajaxTab('route', function() {
					$('#route-comment').val(routeComment);
				});
			};

			objProposal.togglePendingRoute(this, previewCallback, editCallback);
		});

		$('body').on('click', '#cancel-custom-route', _.debounce(function(event) {
			event.preventDefault();
			event.stopPropagation();
			var stepID = $('#route .tab-content-item-space:eq(0) ul.steps li:eq(0)')
							.attr('id')
							.replace('step-','');
			customRouteObject.deletePendingRoute(stepID);
		}, 1000, true));

		/* Update Steps Buttons */
		approvalProcessObject.bindStepEvents('proposal');

		$('#curriculog-steps-column-content').on('keyup', '#route-comment', function(event) {
			$.validity.start();
			$('#route-comment').require().assert(function(){
				// disallow whitespace only comments
				return $('#route-comment').val().trim().length > 0;
			}, "Comment is required.");
			var result = $.validity.end();
		});
	};

	objProposal.initDecisionBindings = function() {
		$('#decisions').on('click', 'input[name^="make-decision"]', function(event) {
			var decision = $(this).closest('fieldset').find('input[name^="make-decision"]:checked').val();

			var comment = $(this).closest('fieldset').find('.decision-comment textarea');

			if ($.inArray(decision, ['approve', 'relaunch', 'create-route']) !== -1) {
				$(comment).removeClass('required');
			} else {
				$(comment).addClass('required');
			}

			objProposal.validate($(comment),event);
			Backbone.trigger('form:stretch');
		});

		$('#curriculog-steps-column-content').on('click', '.decision-options input', function(event) {
			var comment = $(this).closest('fieldset').find('.decision-comment textarea');
			var decision = $(this);

			if ($(this).attr('value') === 'create-route') {
				$(comment).attr('disabled', 'disabled');
				$(comment).attr('value', 'Please comment after your route is created.');


				$('input[name^="make-decision"]').each(function() {
					if ($(this).attr('value') === 'create-route' &&
							$(this).attr('name') !== decision.attr('name')) {
						$(this).attr('disabled', true);
					}
				});
			} else {
				$(comment).removeAttr('disabled');
				if($(comment).val() == 'Please comment after your route is created.') {
					$(comment).val('');
				}
			}
		});

		$('#curriculog-steps-column-content').on('change', '.error', function (event) {
			objProposal.validate($(this), event);
			Backbone.trigger('form:stretch');
		});

		$('#curriculog-steps-column-content').on('keyup', 'textarea[name="decision-comment"]', function (event) {
			if($(this).closest('fieldset').find('input[name^="make-decision"]:checked').length){
				objProposal.validate(this, event);
			}
		});

		$('#curriculog-steps-column-content').on('click', 'button[name="submit-decision"]:not(:disabled)', _.debounce(function (event) {
			event.preventDefault();
			$(this).blur();

			var decision = $(this).closest('fieldset').find('input[name^="make-decision"]:checked').val();

			$(this).siblings('.js-unsaved-error').remove();
			if (app.formView.hasUnsavedChanges()) {
				var err = $('<span class="error js-unsaved-error">The proposal has unsaved changes. Please save or cancel these changes before continuing.</span>');
				err.insertBefore(this);
			}

			objProposal.validate($(this).closest('fieldset').find('textarea[id^="decision-comment"]'), event);

			if ($(this).closest('fieldset').find('input.error, textarea[id^="decision-comment"].error, .js-unsaved-error').size() < 1) {
				var decisionFieldset = $(this).closest('fieldset');
				objProposal.makeDecision(decision, decisionFieldset);
			} else {
				Backbone.trigger('form:stretch');
			}

		}, 1000, true));
	};

	objProposal.initUploadBindings = function () {
		// Files
		$('#curriculog-steps-column-content').on('click', '#s3-upload', function (event) {
			event.preventDefault();

			// needed to do it this way so it works in Chrome, IE, and Safari
			var real = $('#curriculog-proposal #upload_file');

			// validation
			if (validationObject.isEmpty($(real).val().trim())) {
				validationObject.addError(real, 'file-ext', true, true);
			}

			if (!validationObject.isValidExtension($(real).val().trim())) {
				validationObject.addError(real, 'file-ext', false, false);
			}

			var filesList = real[0].files,
				fileSizeInMB = 0;

			if (filesList.length > 0) {
				fileSizeInMB = real[0].files[0].size/1024/1024;
			}

			// maxUploadFileSize is computed and set in ProposalController.php
			if (fileSizeInMB > maxUploadFileSize) {
				validationObject.addErrorMessage('file-size', 'File size exceeds ' + maxUploadFileSize + 'M limit.');
				validationObject.addError(real, 'file-size', false, true);
			}

			if (validationObject.hasErrors($('#files')) === 0) {
				$('#files').mask('Uploading');
				var cloned = real.clone(true);
        real.hide();
			  cloned.insertAfter(real);
				real.appendTo('#file_upload');

        var s3FormData = new FormData(document.forms['file_upload']);
        var request = new XMLHttpRequest();
        request.onload = function(){
          $('#files').unmask();
					// we need to replace the input with a new one so that they don't upload the same file
					$('#file_upload #upload_file').remove();
					$('#upload_file').replaceWith('<input id="upload_file" class="upload" type="file" name="upload_file" aria-label="Choose File">');
          objProposal.ajaxTab('files');
          Backbone.trigger('form:stretch');
        };
        request.open("POST", location.href.replace("form", "upload"));
        request.send(s3FormData);
			} else {
				Backbone.trigger('form:stretch');

				// we need to replace the input with a new one so that they don't upload the same file
				$('#file_upload #upload_file').remove();
				$('#upload_file').replaceWith('<input id="upload_file" class="upload error" type="file" name="upload_file" aria-label="Choose File">');
			}
		});

		$('#curriculog-steps-column-content').on('change', '#upload_file.error', function(event) {
			if ( !validationObject.isEmpty($(this).val().trim()) &&
				validationObject.isValidExtension($(this).val().trim()) ) {
				validationObject.removeError(this, 'file-ext');
			}
		});
		//

		// Actions: focus-within css workaround
		var previousListColumnResult;
		$('#curriculog-steps-column-content').on('focus','.file-page', function(){
				$(this).addClass('focus-within');
		});
		$('#curriculog-steps-column-content').on('blur','.file-page', function(event){
				if ($(event.relatedTarget).parents('#files-content').length === 0 ){
					$(this).removeClass('focus-within');
				}
		});

		$('#curriculog-steps-column-content').on('click', '#s3-delete', function(event) {
			event.preventDefault();
			objProposal.s3DeleteFile(this);
		});

		$('#curriculog-steps-column-content').on('click', '#upload-markup-widget.show-markup', function(event) {
			event.preventDefault();

			var data = {
				display: 'getFormAndUsers',
				showMarkup: 1,
				edits: {}
			};

			$.ajax({
				url: '/proposalTracking:' + app.formView.model.id + '/trackUploadEdits',
				type: 'GET',
				data: data,
				beforeSend: function() {
					objDom.addLoadingMask('#files-content');
				},
				success: function(result) {

					var files = $(result).filter('#files');

					// files
					$('#files-content').html(files);

					// adjust button
					$('#upload-markup-widget').addClass('hide-markup').removeClass('show-markup');
					$('#upload-markup-widget .curriculog-large-widget-text').text('Show Attached Files');

					objDom.removeMask('#files-content');

					Backbone.trigger('form:stretch');

				}
			});
		});

		$('#curriculog-steps-column-content').on('click', '#upload-markup-widget.hide-markup', function(event) {
			event.preventDefault();
			objProposal.ajaxTab('files');
		});
	};

	objProposal.initStatusBindings = function() {
		// Toggle conditional steps open and closed during unlaunched status only
		$('#curriculog-steps-column-content #history').on('click', '.step-notapplicable', function(event) {
			event.preventDefault();
			$(this).toggleClass('open-step');
			Backbone.trigger('form:stretch');
		});

		$('#curriculog-steps-column-content #history').on('click', '.step-incomplete:not(.open-step)', function(event) {
			event.preventDefault();
			event.stopPropagation();
			var stepId = $(this).closest('.step').attr('id').match(/step-(\d*)/)[1];
			objProposal.openFutureStep(stepId);
		});

		$('#curriculog-steps-column-content #history').on('click', '.step-incomplete.open-step:not(.action-no-toggle) .step-titlebar', function(event) {
			event.preventDefault();
			event.stopPropagation();
			var stepId = $(this).closest('.step').attr('id').match(/step-(\d*)/)[1];
			$(this).closest('.step').removeClass('open-step');
			Backbone.trigger('form:stretch');
		});

		// Toggle step options
		$('#curriculog-steps-column-content #history').on('click', '.toggle-step-settings', function(event) {
			event.preventDefault();
			event.stopPropagation();

			$(this).closest('.step').find('.settings').slideToggle(function() {
			    Backbone.trigger('form:stretch');
      }).toggleClass('expanded');
      $(this).attr('aria-expanded', $(this).closest('.step').find('.settings').hasClass('expanded'));
		});

    if (cui_enabled_proposal_form) {
      // Toggle committee members
      $('.steps .participants').on('click', '.participant-committee, .participant-no-committee', function (event) {
        event.preventDefault();
        event.stopPropagation();
        objProposal.toggleCommitteesCUI(this);
        Backbone.trigger('form:stretch');
      });

    } else {
      // Toggle committee members
      $('.steps .participants').on('click', '.scroller', function (event) {
        event.preventDefault();
        event.stopPropagation();
        objProposal.toggleCommittees(this);
        Backbone.trigger('form:stretch');
      });

    }

		$('#curriculog-steps-column-content #history').on('click', '.step-log', function(event) {
			event.preventDefault();
			event.stopPropagation();
			objProposal.openStepLog(this);
		});
	};

	/**
	 * Used in:
	 *  - initStatusBindings()
	 *  - togglePendingRoute()
	 */
	objProposal.openFutureStep = function(stepId, callback, isAdminRequest) {
		var $step = $('#step-' + stepId);
		if ($step.hasClass('step-loaded')) {
			$('#step-' + stepId).addClass('open-step');
			Backbone.trigger('form:stretch');
			return;
		}

		var endpoint = '';
		if (isAdminRequest === true) {
			endpoint = '/calculateParticipantsAdmin'
		} else {
			endpoint = '/calculateParticipants'
		}

		$.ajax({
			url: '/proposalStep:' + stepId + endpoint,
			type: 'GET',
			data: {display: 'getProposalStep'},
			beforeSend: function() {
				objDom.addLoadingMask('#step-' + stepId);
			},
			complete: function() {
				objDom.removeMask('#step-' + stepId);
			},
			success: function(data) {
				$step.contents().remove();
				$step.html($(data).html());
				$step.addClass('open-step step-loaded');
				objDom.removeMask('#step-' + stepId);
				Backbone.trigger('form:stretch');

        if (cui_enabled_proposal_form) {
          // Click event to toggle committee members (since we removed the original step from the list)
  				$('#step-' + stepId + ' .participants').on('click', '.participant-committee, .participant-no-committee', function (event) {
  					event.preventDefault();
  					event.stopPropagation();
  					objProposal.toggleCommitteesCUI(this);
  					callback && callback();
  				});

        } else {
          // Click event to toggle committee members (since we removed the original step from the list)
  				$('#step-' + stepId + ' .participants').on('click', '.scroller', function (event) {
  					event.preventDefault();
  					event.stopPropagation();
  					objProposal.toggleCommittees(this);
  					callback && callback();
  				});

        }

				callback && callback();
			}
		});

	};

	/**
	 * Used in:
	 *  - initRouteBindings()
	 *  - views/procedures/admin/dashboard.multi.default.html.php
	 */
	objProposal.togglePendingRoute = function(button, previewCallback, editCallback, isAdminRequest) {
		/* Function to toggle the pending route on the Proposal Form and the Admin Dashboard

		Params:
			button - the clicked #preview-custom-route button
			previewCallback - the callback used to stretch the appropriate page after loading
				the preview
			editCallback - the callback used to handle the reload of either the custom route tab
				or the dashboard flyout

		Returns: Nothing
		*/

		var buttonData = $(button).data();

		if (buttonData.mode == 'preview') {
			objProposal.openFutureStep(buttonData.stepId, function() {

				// Set click event to toggle step config

          $('#step-' + buttonData.stepId).on('click', '.toggle-step-settings', function(event) {
            event.preventDefault();
            event.stopPropagation();
            $(this).closest('.step').find('.settings').slideToggle(function() {
              previewCallback && previewCallback();
            }).toggleClass('expanded');
            $(this).attr('aria-expanded', $(this).closest('.step').find('.settings').hasClass('expanded'));
          });


				// run the callback (vertical stretching) after loading step
				previewCallback && previewCallback();
			}, isAdminRequest);

			// prepend psa hidden field required for customRoute.js object
			// this is a silly, unnecessary dependency
			// remove when we refactor custom routes
			$('<input />')
				.attr('type', 'hidden')
				.attr('id', 'step-' + buttonData.stepId + '-customAction')
				.attr('name', 'step[' + buttonData.stepId + '][customAction]')
				.attr('value', buttonData.psaId)
				.insertBefore(button);

			var buttonText = (buttonData.isOriginator) ? 'Edit Custom Route' : 'View Route Config';
			$(button).data('mode','edit')
				.find('span').text(buttonText);

		} else {
			// Remove click event to toggle step config
			$('#step-' + buttonData.stepId).off('click', '.toggle-step-settings');
			editCallback && editCallback();
		}
	};

	/**
	 * Used in:
	 *  - initStatusBindings()
	 *  - openFutureStep()
	 */
  objProposal.toggleCommitteesCUI = function(toggle) {
    var scroller = $(toggle).find('.scroller');
    var toggleClass = $(toggle).attr('class');
    var committeeClass;
    if (toggleClass.lastIndexOf('participant-committee') !== -1) {
      committeeClass = '.' + toggleClass.match(/(committee-\d*)/)[1];
    } else {
      committeeClass = '.no-committee';
    }
    if (scroller.hasClass('open')) {
      scroller.addClass('closed').removeClass('open');
      $(toggle).parent('ul').find(committeeClass).removeClass('active');
    } else {
      scroller.addClass('open').removeClass('closed');
      $(toggle).parent('ul').find(committeeClass).addClass('active');
    }
  };

	objProposal.toggleCommittees = function(toggle) {

    if ($(toggle).closest('.participant-committee').attr('class') !== undefined) {
			var committeeID = $(toggle).closest('.participant-committee').attr('class').match(/(committee-\d*)/)[1];
			if ($(toggle).hasClass('open')) {
				// turn off and show link instead
				$(toggle).removeClass('open').addClass('closed');
				$(toggle).parent('.participant-committee').parent('ul').find('.participant-nonadmin.' + committeeID).removeClass('active');

			} else {

				// turn on and turn off link
				$(toggle).addClass('open').removeClass('closed');
				$(toggle).parent('.participant-committee').parent('ul').find('.participant-nonadmin.' + committeeID).addClass('active');
			}

		} else {
			if ($(toggle).hasClass('open')) {
				// turn off and show link instead
				$(toggle).removeClass('open').addClass('closed');
				$(toggle).parent('.participant-no-committee').parent('ul').find('.no-committee').removeClass('active');

			} else {
				// turn on and turn off link
				$(toggle).addClass('open').removeClass('closed');
				$(toggle).parent('.participant-no-committee').parent('ul').find('.no-committee').addClass('active');
			}
		}
	};

	objProposal.initCommentBindings = function() {

		//TODO: dont hack
		app.formView.trackingDropdown.initialize();
		// objProposal.initializeTrackingDropdowns();

    // User Tracking Help
    $('#toggle-user-tracking-help').on('click', function(event) {
      $(this).children('.screen-reader-text').text(
        $(this).children('.screen-reader-text').text() === 'Show User Tracking Help Text' ? 'Hide User Tracking Help Text' : 'Show User Tracking Help Text'
      );
      $('#user-tracking-help').slideToggle('fast');
      $(this).toggleClass('active');
    });

		// Comment on Proposal
		$('#curriculog-steps-column-content #comments').on('click', 'a.add-comment', function(event) {
			event.preventDefault();
			objProposal.addCommentDialog();
		});

		// Reply to Proposal
		$('#curriculog-steps-column-content #comments').on('click', 'a.reply', function(event) {
			event.preventDefault();

			objProposal.replyToCommentDialog($(this).parents('.comment').attr('id').replace('comment-',''));
		});

		// Show replies
		$('#curriculog-steps-column-content #comments').on('click', 'a.view-replies', function(event) {
			event.preventDefault();

			objProposal.showReplies($(this).parents('.comment').attr('id').replace('comment-',''));
		});
	};

	objProposal.destroyCrosslistingBindings = function() {
		$('#curriculog-steps-column').off('click','#add-crosslisting-course');
		$('#curriculog-steps-column').off('click','.select-crosslisting');
		$('#curriculog-steps-column').off('click','.crosslisting-remove');
	};

	objProposal.destroyProposalLookupBindings = function() {
		$('#proposal-lookup-list-column-results-content').off('focus','.proposal-lookup-summary');
		$('#proposal-lookup-list-column-results-content').off('blur','.proposal-lookup-summary');
	};

	objProposal.destroyRouteBindings = function() {
		$('body').off('click', '#request-custom-route');
		$('body').off('click', '#preview-custom-route');
		$('body').off('click', '#cancel-custom-route');
		approvalProcessObject.unbindStepEvents();
		$('#curriculog-steps-column-content').off('keyup', '#route-comment');
	};

	objProposal.destroyDecisionBindings = function() {
		//console.log('unbinding decisions');
		$('#decisions').off('click', 'input[name^="make-decision"]');
		$('#curriculog-steps-column-content').off('click', '.decision-options input');
		$('#curriculog-steps-column-content').off('change', '.error');
		$('#curriculog-steps-column-content').off('keyup', 'textarea[name="decision-comment"]');
		$('#curriculog-steps-column-content').off('click', 'button[name="submit-decision"]:not(:disabled)');
	};

	objProposal.destroyUploadBindings = function() {
		// Files
		$('#curriculog-steps-column-content').off('click', '#s3-upload');
		$('#curriculog-steps-column-content').off('change', '#upload_file.error');
		$('#curriculog-steps-column-content').off('click', '#s3-delete');
		$('#curriculog-steps-column-content').off('click', '#upload-markup-widget.show-markup');
		$('#curriculog-steps-column-content').off('click', '#upload-markup-widget.hide-markup');
	};

	objProposal.destroyStatusBindings = function() {
		$('#curriculog-steps-column-content #history').off('click', '.step-notapplicable');
		$('#curriculog-steps-column-content #history').off('click', '.toggle-step-settings');
		$('#curriculog-steps-column-content #history').off('click', '.step-incomplete, .step-notapplicable');
		$('#curriculog-steps-column-content #history').off('click', '.step-incomplete:not(.open-step)');
		$('#curriculog-steps-column-content #history').off('click', '.step-incomplete.open-step .step-titlebar');
		$('#curriculog-steps-column-content #history').off('click', '.step-log');
		$('.steps .participants').off('click', '.scroller');
	};

	objProposal.destroyCommentBindings = function() {
		$('#curriculog-steps-column-content #comments').off('click', 'a.add-comment');
		$('#curriculog-steps-column-content #comments').off('click', 'a.reply');
		$('#curriculog-steps-column-content #comments').off('click', 'a.view-replies');
		$('#curriculog-steps-column-content').off('click', '.previous, .next');
	};

	/**
	 * Used in:
	 *  - showConflict() - for assessments
	 */
	objProposal.initializeConflictMarkupDropdowns = function(conflictId) {
		// User Edits Dropdown - declare first because it interacts with editing
		$('#field-conflict-dropdown-' + conflictId).multiselect({
			minWidth:600,
			classes: 'edits-filter-multiselect conflict-select',
			height: 80,
			header: false,
			selectedText: function(numChecked, numTotal, checkedItems){
				return $('#ui-multiselect-field-conflict-dropdown-'+conflictId+'-option-' + checkedItems).attr('title');
			},
			noneSelectedText: 'Show current with markup',
			multiple: false,
			click: function(event, ui){
				$('#field-conflict-dropdown-' + conflictId).find('option').removeAttr('selected');

				if (ui.text === 'Show current with markup') {
					$('#field-conflict-dialog-' + conflictId + ' .field-conflicts').hide();
					$('#field-conflict-diff-' + conflictId).show();

					$('.conflict-select span:not(.ui-icon)').text('Show current with markup');
					$('#field-conflict-dropdown-' + conflictId +' option[value="currentMarkup"]').attr('selected', 1);
					$('#field-conflict-dropdown-' + conflictId).multiselect('refresh');

				} else if (ui.text === 'Show original') {
					$('#field-conflict-dialog-' + conflictId + ' .field-conflicts').hide();
					$('#field-conflict-original-' + conflictId).show();

					$('.conflict-select span:not(.ui-icon)').text('Show original');
					$('#field-conflict-dropdown-' + conflictId + ' option[value="original"]').attr('selected', 1);
					$('#field-conflict-dropdown-'+ conflictId).multiselect('refresh');

				} else {
					$('#field-conflict-dialog-'+conflictId+' .field-conflicts').hide();
					$('#field-conflict-current-'+conflictId).show();

					$('.conflict-select span:not(.ui-icon)').text('Show current');
					$('#field-conflict-dropdown-' + conflictId + ' option[value="current"]').attr('selected', 1);
					$('#field-conflict-dropdown-' + conflictId).multiselect('refresh');
				}

				$('#field-conflict-dropdown-' + conflictId).multiselect('refresh');
			}
		});
	};

	objProposal.getImportErrors = function() {
		if (window.app.proposalImportData) {
			for (var i = 0; i < window.app.proposalImportData.length; i++) {
				var importField = window.app.proposalImportData[i];
				var errors = importField.errors.concat(importField.warnings);
				for (var j = 0; j < errors.length; j++ ) {
					var fieldId = $('.section-fieldset[data-map-id=' + importField.id + ']').data('id');
					var field_view = app.formView.getField(fieldId);
					// If this is a normal field with a backbone view/model
					if (field_view) {
						var field_model = field_view.model;
						field_view.showError(field_model, errors[j], {clear: false});
						continue;
					}

					// Otherwise, default to legacy code. (currently for assments and curriculum)
					var errorMessage = '<span class="error import-error">' + errors[j] + '</span><br>';
					// :last selector is for widgets to grab the last text area in the set,
					// and should not affect regular fields.
					var fieldEl = $('.section-fieldset.field-' + fieldId + ' .option-groups:last');
					fieldEl.append(errorMessage);
				}
			}
		}
	};


	// Fixes issue-126
	// The events aren't bound when the decision tab is activated by the
	// query string param in the url. This happens when being redirected
	// from the agenda after making a request decision.
	if (window.location.href.match(/tab=decisions/) !== null) {
		objProposal.initDecisionBindings();
	}

	return objProposal;
};

// FIXME This file is too big.
